module.exports = __webpack_public_path__ + "img/checo-1.c3cf07d5.png";